<template>
  <TheMainContent class="text-static-default-hi bg-surface-default-low pb-56">
    <Main :comparisonData :comparisonPending />
    <RelatedContent />
  </TheMainContent>
</template>

<script lang="ts" setup>
import { useRoute } from '#imports'
import { computed } from 'vue'

import TheMainContent from '~/components/TheMainContent/TheMainContent.vue'

import Main from '../../components/Results/Main/Main.vue'
import RelatedContent from '../../components/Results/RelatedContent/RelatedContent.vue'
import {
  handleComparisonError,
  useFetchResultsPage,
} from '../../composables/useFetchResultsPage/useFetchResultsPage'

const route = useRoute()
const model1 = computed(() => route.params.productA as string)
const model2 = computed(() => route.params.productB as string)

const {
  data: comparisonData,
  pending: comparisonPending,
  error,
} = await useFetchResultsPage(model1, model2)

if (error.value) await handleComparisonError(error.value)
</script>
